import * as React from "react";

/**
 * Executes the latest passed callback when component is unmounted.
 */
export const useOnUnmount = (callback: F) => {
    const callbackRef = React.useRef(callback);
    callbackRef.current = callback;
    React.useEffect(() => () => callbackRef.current(), []);
};
